import type { IsoDate, IsoDateTime } from '@omnipresentgroup/design-system';

export enum ResignationStatus {
  REQUESTED = 'Requested',
  REVIEWED = 'Reviewed',
}

export type Resignation = {
  id: string;
  companyId: string;
  employeeId: string;
  employmentId: string;
  employeeLastWorkingDay: IsoDate;
  isManagerAware: boolean;
  employeeScheduledLeaves: string[];
  employeeNumberOfVacationsDays: number;
  resignationReason: string;
  otherReason?: string;
  status?: ResignationStatus;
  createdBy: string;
  createdAt: IsoDateTime;
};

export enum EmployeeScheduledLeavesConstants {
  NOT_APPLICABLE = 'notApplicable',
  SICK_LEAVE = 'sickLeave',
  PARENTAL_LEAVE = 'parentalLeave',
  COMPASSIONATE_LEAVE = 'compassionateLeave',
  VACATION_LEAVE = 'vacationLeave',
  STUDY_LEAVE = 'studyLeave',
  GARDENING_LEAVE = 'gardeningLeave',
  DAYS_OWED = 'daysOwed',
  OTHER = 'other',
}

export enum ResignationReasonsConstants {
  FLEXIBLE_WORK_OPTIONS = 'flexibleWorkOptions',
  MOVING_TO_DIRECT_EMPLOYER = 'movingToDirectEmployer',
  NON_REMOTE_OPTIONS = 'nonRemoteOptions',
  CONTRACTUAL_COMPLETION = 'contractualCompletion',
  JOB_SATISFACTION = 'jobSatisfaction',
  BETTER_BENEFITS = 'betterBenefits',
  RETURN_TO_STUDY = 'returnToStudy',
  BETTER_CAREER_OPPORTUNITIES = 'betterCareerOpportunities',
  PERSONAL_REASONS = 'personalReasons',
  OTHER = 'other',
}

export const EmployeeScheduledLeavesOptions: { [key: string]: string } = {
  [EmployeeScheduledLeavesConstants.NOT_APPLICABLE]: 'Not applicable',
  [EmployeeScheduledLeavesConstants.SICK_LEAVE]: 'Sick leave',
  [EmployeeScheduledLeavesConstants.PARENTAL_LEAVE]:
    'Maternity/Paternity leave',
  [EmployeeScheduledLeavesConstants.COMPASSIONATE_LEAVE]: 'Compassionate leave',
  [EmployeeScheduledLeavesConstants.VACATION_LEAVE]:
    'Paid/Unpaid vacation leave',
  [EmployeeScheduledLeavesConstants.STUDY_LEAVE]: 'Study leave',
  [EmployeeScheduledLeavesConstants.GARDENING_LEAVE]: 'Gardening leave',
  [EmployeeScheduledLeavesConstants.DAYS_OWED]: 'Days owed',
  [EmployeeScheduledLeavesConstants.OTHER]: 'Other',
};

export const EmployeeScheduledLeavesOptionsArray = Object.entries(
  EmployeeScheduledLeavesOptions,
).map(([key, value]) => ({
  const: key,
  title: value,
}));

export const ResignationReasonsOptions: { [key: string]: string } = {
  [ResignationReasonsConstants.FLEXIBLE_WORK_OPTIONS]:
    'Seeking more flexible work options',
  [ResignationReasonsConstants.MOVING_TO_DIRECT_EMPLOYER]:
    'Moving to a direct employer',
  [ResignationReasonsConstants.NON_REMOTE_OPTIONS]:
    'Seeking non-remote options',
  [ResignationReasonsConstants.CONTRACTUAL_COMPLETION]:
    'Contractual change/completion',
  [ResignationReasonsConstants.JOB_SATISFACTION]: 'Job satisfaction',
  [ResignationReasonsConstants.BETTER_BENEFITS]: 'Better remuneration/benefits',
  [ResignationReasonsConstants.RETURN_TO_STUDY]: 'Return to study/retraining',
  [ResignationReasonsConstants.BETTER_CAREER_OPPORTUNITIES]:
    'Better career opportunities',
  [ResignationReasonsConstants.PERSONAL_REASONS]:
    'Personal reasons unrelated to the job',
  [ResignationReasonsConstants.OTHER]: 'Other',
};

export const ResignationReasonsOptionsArray = Object.entries(
  ResignationReasonsOptions,
).map(([key, value]) => ({
  const: key,
  title: value,
}));
